fccd-select {
  width: 100%;
}
